import { API_URL } from '../constants/global.constants';
import socket, { getSessionKey, setSessionKey } from '../socket';
import { x_key } from '../socket.config';
import { delay } from '../utils/delay';

export const getApi = async (apiUrl: string) => {
  const sessionKey = getSessionKey() as string; // localStorage.getItem('x-session-key') || '';
  try {
    const response = await fetch(`${API_URL}/${apiUrl}`, {
      headers: {
        'x-api-key': x_key,
        'x-session-key': sessionKey,
      },
    });

    if (!response.ok) {
      if (response.status === 400) {
        const errorData = await response.json();
        if (errorData && errorData.statusCode) {
          const data = { statusCode: errorData.statusCode };
          console.error('TCL -> getApi -> data:', data);
          localStorage.removeItem('x-session-key');
          await setSessionKey();
          let retryCount = 5;
          // eslint-disable-next-line no-constant-condition
          while (retryCount > 0) {
            retryCount--;
            await delay(5000);
            if (socket && socket.connected) {
              break;
            }
          }

          if (retryCount < 0 && (!socket || !socket.connected)) {
            console.error('handle later');
          }
          const resData: any = await getApi(apiUrl);
          return resData;
        }
      }
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    throw new Error(`Error fetching data: ${error.message}`);
  }
};

export const postApi = async (
  requestBody: any,
  apiUrl: string,
  reqHeaders = {},
  isContentType = true,
  baseUrl = API_URL,
) => {
  const sessionKey = getSessionKey() as string; // localStorage.getItem('x-session-key') || '';
  const headers:any = {
    'x-api-key': x_key,
    'x-session-key': sessionKey,
    ...reqHeaders,
  };
  if (isContentType) {
    headers['Content-Type'] = 'application/json';
  } else {
    if (headers['Content-Type']) {
      delete headers['Content-Type'];
    }
  }
  try {
    const response = await fetch(`${baseUrl}/${apiUrl}`, {
      method: 'POST',
      headers,
      body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
    });
    if (!response.ok) {
      if (response.status === 400) {
        const errorData = await response.json();
        if (errorData && errorData.statusCode) {
          const data = { statusCode: errorData.statusCode };
          console.error('TCL -> data:', data);
          localStorage.removeItem('x-session-key');
          if (socket && socket.connected) socket.disconnect();
          await setSessionKey();
          let retryCount = 5;
          console.error('TCL -> start -> retryCount:', retryCount);
          // eslint-disable-next-line no-constant-condition
          while (retryCount > 0) {
            retryCount--;
            await delay(5000);
            if (socket && socket.connected) {
              break;
            }
            console.error('TCL -> inner -> retryCount:', retryCount);
          }
          if (retryCount < 0 && (!socket || !socket.connected)) {
            console.error('handle later');
          }
          const resData: any = await postApi(requestBody, apiUrl, reqHeaders);
          return resData;
        }
      }
    }
    const data = await response.json();
    return data;
  } catch (error: any) {
    throw new Error(`Error posting data: ${error.message}`);
  }
};

export const putData = async (id: number, requestBody: any, apiUrl: string) => {
  const sessionKey = getSessionKey() as string; // localStorage.getItem('x-session-key') || '';
  try {
    const response = await fetch(`${API_URL}/${apiUrl}/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-session-key': sessionKey,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      if (response.status === 400) {
        const errorData = await response.json();
        if (errorData && errorData.statusCode) {
          const data = { statusCode: errorData.statusCode };
          console.error('TCL -> putData -> data:', data);
          localStorage.removeItem('x-session-key');
          await setSessionKey();
          let retryCount = 5;
          // eslint-disable-next-line no-constant-condition
          while (retryCount > 0) {
            retryCount--;
            await delay(5000);
            if (socket && socket.connected) {
              break;
            }
          }

          if (retryCount < 0 && (!socket || !socket.connected)) {
            console.error('handle later');
          }
          const resData: any = putData(id, requestBody, apiUrl);
          return resData;
        }
      }
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    throw new Error(`Error updating data: ${error.message}`);
  }
};
